export const getPaidServiceRequests = (state) => state.paidServiceRequests.results;
export const getPaidRequestsCount = (state) => state.paidServiceRequests.count;